// extracted by mini-css-extract-plugin
export default {"detail_title":"DetailCell_detail_title__om3H2","detail_value":"DetailCell_detail_value__z5hgT"};